let upload = {
  data() {
    return {};
  },
  methods: {
    upload(obj) {
      console.log("obj upload", obj);
      return new Promise(resolve => {
        resolve(obj);
      });
    }
  }
};

export default upload;
